import axios from 'axios';
import setAuthToken from '../services/setAuthToken';
import * as types from './index';

export const loadUser = () => async (dispatch) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await axios.get('https://ncode-backend.herokuapp.com');
    dispatch({
      type: types.USER_LOADED,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: types.AUTH_ERROR,
    });
  }
};

export const register = ({ name, email, username, password }) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const body = JSON.stringify({ name, email, username, password });
  try {
    const res = await axios.post('https://ncode-backend.herokuapp.com', body, config);
    dispatch({
      type: types.REGISTER_USER_SUCCESS,
      payload: res.data,
    });
    dispatch(loadUser());
  } catch (error) {
    dispatch({
      type: types.REGISTER_USER_ERROR,
    });
  }
};

export const login = ({ email, password }) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const body = JSON.stringify({ email, password });
  try {
    const res = await axios.post('https://ncode-backend.herokuapp.com/login', body, config);
    dispatch({
      type: types.LOGIN_USER_SUCCESS,
      payload: res.data,
    });
    dispatch(loadUser());
  } catch (error) {
    dispatch({
      type: types.LOGIN_USER_ERROR,
    });
  }
};

export const logout = () => (dispatch) => {
  dispatch({ type: types.LOGOUT });
};
